// extracted by mini-css-extract-plugin
export var blockTitle = "typography-module--block-title--7d24e";
export var question = "typography-module--question--5b81d";
export var related = "typography-module--related--042cf";